function getQueryParams(name) {
  const params = {};
  const searchParams = new URLSearchParams(document.location.search);

  if (name) {
    return searchParams.get(name);
  }

  searchParams.forEach((value, key) => {
    const matches = key.match(/^(.+?)\[(.+)\]$/);
    if (matches) {
      const [_, group, subKey] = matches;
      params[group] = params[group] || {};
      params[group][subKey] = value;
    } else {
      params[key] = value;
    }
  });

  return params;
}

function saveFormDataToSession(data, key = 'formData') {
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    console.error('Error saving to session storage:', e);
  }
}

function getFormDataFromSession(key = 'formData') {
  try {
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.error('Error reading from session storage:', e);
    return null;
  }
}

function clearFormDataFromSession(key = 'formData') {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    console.error('Error clearing session storage:', e);
  }
}

function getShopifyLink(fileName, location = 'asset') {
  if (!window.Shopify.links) {
    return;
  }

  const baseLink = window.Shopify.links[location];

  return baseLink.replace('XXX.XXX', fileName);
}

function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options = {}) {
  options.path = '/';

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += '; ' + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

function uuidv4() {
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
    (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
  );
}

function toHandle(string) {
  if (!string) {
    return;
  }

  return string
    .trim()
    .toLowerCase()
    .replace(/(\s)|(\.)/g, '-')
    .replace(/[\(\)\,'"]+/g, '');
}

function serializeForm(form) {
  // Setup our serialized data
  const serialized = {}; // Loop through each field in the form

  for (let i = 0; i < form.elements.length; i++) {
    const field = form.elements[i]; // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields

    if (
      !field.name ||
      field.disabled ||
      field.type === 'file' ||
      field.type === 'reset' ||
      field.type === 'submit' ||
      field.type === 'button'
    )
      continue; // If a multi-select, get all selections

    if (field.type === 'select-multiple') {
      for (let n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized[field.name] = field.options[n].value;
      }
    } // Convert field data to a query string
    else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized[field.name] = field.value;
    }
  }

  return serialized;
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || Shopify.moneyFormat;

  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function formatImage(src, size = '150x150', crop) {
  if (src != null) {
    size = '_' + size;

    if (crop) {
      size += `_crop_${crop}`;
    }

    if (src.indexOf('.jpg') !== -1) {
      const splitUrl = src.split('.jpg');
      src = splitUrl[0] + size + '@2x.jpg';
    } else if (src.indexOf('.jpeg') !== -1) {
      const splitUrl = src.split('.jpeg');
      src = splitUrl[0] + size + '@2x.jpeg';
    } else if (src.indexOf('.png') !== -1) {
      const splitUrl = src.split('.png');
      src = splitUrl[0] + size + '@2x.png';
    }
  }

  return src;
}

function clone(value) {
  return !value ? null : JSON.parse(JSON.stringify(value));
}

function throttle(callback, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall >= delay) {
      lastCall = now;
      callback(...args);
    }
  };
}

function debounce(callback, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => callback(...args), delay);
  };
}

function getUsuallyShips(variant) {
  const shipsFrom = getShipsFrom(variant);
  const isShipsFromChina = shipsFrom ? shipsFrom.toLowerCase().includes('china') : false;
  const usuallyShips = variant.usually_ships_within;

  const isPreOrder =
    variant.inventory_management !== null &&
    variant.inventory_policy === 'continue' &&
    variant.inventory_quantity < 1;

  if (isShipsFromChina || isPreOrder) {
    return Shopify.strings.shippingText;
  }

  if (usuallyShips) {
    return `Usually ships within ${usuallyShips.replace('-', ' to ')} days`;
  }
}

function getDetails(variant) {
  const hasNA = variant.options.includes(Shopify.strings.na);
  let details = `SKU: ${variant.sku || variant.name}`;
  let plug = Shopify.currentCountry?.plug;

  if (hasNA) {
    return details;
  }

  if (variant.plugs?.every(p => !p.includes(plug))) {
    plug = variant.plugs[0];
  }

  if (plug && variant.options_title.includes(Shopify.strings.voltage)) {
    return `${details} - Plug: ${plug}`;
  }
}

function getShipsFrom(variant) {
  let shipsFrom = variant.ships_from;

  if (!shipsFrom) {
    if (variant.title.includes('220V')) {
      shipsFrom = 'China';
    } else {
      shipsFrom = 'United States';
    }
  }

  return shipsFrom;
}
